import { render, staticRenderFns } from "./CapillaryLocationsTemplate.vue?vue&type=template&id=aef4aabe"
import script from "./CapillaryLocationsTemplate.vue?vue&type=script&lang=js"
export * from "./CapillaryLocationsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports